import { Injectable } from '@angular/core';
import { HttpRequestPayload, IHttpErrorPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from '@core/service';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { PreLoginService } from 'src/app/pre-login/pre-login.service';
import { IOpenPurchaseOrderPayload } from '../../purchase-order/model/purchase-order.model';
import { IOpenSellOrder } from '../model/sell-order.model';

@Injectable({
  providedIn: 'root'
})
export class SellOrderService {

  constructor(private _httpProviders: HttpProviderService,
    private _preLoginService: PreLoginService) {}

  openSellOrder(payload: IOpenPurchaseOrderPayload) {
    const httpRequestPayload: HttpRequestPayload = {
      method: "POST",
      resource: "/mfsellorder",
      body: payload,
    };
    return this._httpProviders.invokeApi(httpRequestPayload).pipe(
      map(
        (response: IHttpSuccessPayload<any>) => {
          const mfsellorderResponse = {
            httpStatus : response.status,
            inventoryNo : response.body.mfsellorder.inventoryNumber,
            refNo: response.body.mfsellorder.refNo,
          }
          if (response.status == 201) {
            this._preLoginService.setUserTwoFactor({ email: response.body.mfsellorder.twoFactor?.email, mobile: response.body.mfsellorder.twoFactor?.mobile });
          }
          return mfsellorderResponse
        },
        catchError((err: IHttpErrorPayload) => {
          return of(err);
        })
      )
    );
  }
  fetchSellOrderDetails(requestReference:any): Observable<any> {
    const request: HttpRequestPayload = {
      resource: `/mfsellorder/${requestReference}`,
      method: 'GET',
    };
    return this._httpProviders.invokeApi(request).pipe(
      map(
        (response: IHttpSuccessPayload<any>) => {
          console.log(response);
          return response.body.mfsellorder;
        },
        catchError((err: IHttpErrorPayload) => {
          return of(err);
        })
      )
    );
  }
  fetchSellOrderDetailsById(requestReference): Observable<IOpenSellOrder> {
    const httpRequest : HttpRequestPayload = {
      resource : `/mfsellorder/${requestReference}`,
      method : "GET"
    }
    return this._httpProviders.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      const requestSellOrderResponse : IOpenSellOrder = response.body.mfsellorder
      return requestSellOrderResponse
    },
    catchError((err : IHttpErrorPayload) => { 
      return throwError(err)
    })));
  }
}
